export default __webpack_public_path__ + "static/media/gallery-big-03.2201d944.jpg";